import Products from 'merchandise-lib/constants/Product';
export const FALLBACK_PUBLIC_PURCHASE_MOTIONS = {
  MERCH_CARD: {
    purchaseMotions: {
      [Products.MARKETING_HUB_STARTER]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.OPERATIONS_HUB_PROFESSIONAL]: [{
        key: 'TRIAL'
      }, {
        key: 'BUY_TOUCHLESS'
      }],
      [Products.CMS_HUB_PROFESSIONAL_ONBOARDING]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.TECH_SERVICE_DEDICATED_IP_FOR_EMAIL]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.WEB_HOSTING_CUSTOM_SSL_PACK]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.SERVICE_HUB_STARTER]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.TECHNICAL_CONSULTING_ONGOING]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.SALES_HUB_STARTER]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.SERVICE_HUB_ENTERPRISE]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.CMS_HUB_ENTERPRISE]: [{
        key: 'TALK_TO_SALES'
      }, {
        key: 'TRIAL'
      }],
      [Products.STRATEGIC_CONSULTING_ONGOING]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.SERVICE_HUB_ENTERPRISE_ONBOARDING]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.SALES_HUB_ENTERPRISE]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.SERVICE_HUB_STARTER_ONBOARDING]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.TRAINING_AGENCY_MARKETING_HUB_FUNDAMENTALS]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.DOMAINS_LIMIT_INCREASE]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.MARKETING_HUB_PROFESSIONAL]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.PREMIUM_CONSULTING]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.API_LIMIT_INCREASE]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.TRANSACTIONAL_EMAIL]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.MARKETING_HUB_STARTER_ONBOARDING]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.SALES_HUB_ENTERPRISE_ONBOARDING]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.OPERATIONS_HUB_ENTERPRISE]: [{
        key: 'TRIAL'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.CMS_HUB_PROFESSIONAL]: [{
        key: 'TALK_TO_SALES'
      }, {
        key: 'TRIAL'
      }],
      [Products.ADS_LIMIT_INCREASE]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.BRAZIL_ONBOARDING]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.MARKETING_HUB_ENTERPRISE]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.CMS_HUB_ENTERPRISE_ONBOARDING]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.SALES_HUB_PROFESSIONAL]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.MARKETING_HUB_PROFESSIONAL_ONBOARDING]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.STRATEGIC_CONSULTING_MONTHLY]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.OPERATIONS_HUB_STARTER]: [{
        key: 'BUY_TOUCHLESS'
      }],
      [Products.SALES_HUB_PROFESSIONAL_ONBOARDING]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.SERVICE_HUB_PROFESSIONAL]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.SALES_HUB_STARTER_ONBOARDING]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.CMS_HUB_STARTER]: [{
        key: 'BUY_TOUCHLESS'
      }],
      [Products.SERVICE_HUB_PROFESSIONAL_ONBOARDING]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.BRAND_DOMAIN]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.HUBSPOT_FOR_STARTUPS_SETUP]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.REPORTING_LIMIT_INCREASE]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.TRANSCRIPTION_LIMIT_INCREASE]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }]
    }
  },
  CALCULATOR: {
    purchaseMotions: {
      [Products.MARKETING_HUB_STARTER]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.OPERATIONS_HUB_PROFESSIONAL]: [{
        key: 'BUY_TOUCHLESS'
      }],
      [Products.TECH_SERVICE_DEDICATED_IP_FOR_EMAIL]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.CMS_HUB_PROFESSIONAL_ONBOARDING]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.SERVICE_HUB_STARTER]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.WEB_HOSTING_CUSTOM_SSL_PACK]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.PHONE_LIMIT_INCREASE]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.TECHNICAL_CONSULTING_ONGOING]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.SALES_HUB_STARTER]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.SERVICE_HUB_ENTERPRISE]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.CMS_HUB_ENTERPRISE]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.STRATEGIC_CONSULTING_ONGOING]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.SERVICE_HUB_ENTERPRISE_ONBOARDING]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.CALLING_LIMIT_INCREASE]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.SALES_HUB_ENTERPRISE]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.SERVICE_HUB_STARTER_ONBOARDING]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.TRAINING_AGENCY_MARKETING_HUB_FUNDAMENTALS]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.DOMAINS_LIMIT_INCREASE]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.MARKETING_HUB_PROFESSIONAL]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.PREMIUM_CONSULTING]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.API_LIMIT_INCREASE]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.TRANSACTIONAL_EMAIL]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.MARKETING_HUB_STARTER_ONBOARDING]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.OPERATIONS_HUB_ENTERPRISE]: [{
        key: 'TRIAL'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.SALES_HUB_ENTERPRISE_ONBOARDING]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.CMS_HUB_PROFESSIONAL]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.ADS_LIMIT_INCREASE]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.BRAZIL_ONBOARDING]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.MARKETING_HUB_ENTERPRISE]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.CMS_HUB_ENTERPRISE_ONBOARDING]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.SALES_HUB_PROFESSIONAL]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.MARKETING_HUB_PROFESSIONAL_ONBOARDING]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.STRATEGIC_CONSULTING_MONTHLY]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.OPERATIONS_HUB_STARTER]: [{
        key: 'BUY_TOUCHLESS'
      }],
      [Products.SALES_HUB_PROFESSIONAL_ONBOARDING]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.SERVICE_HUB_PROFESSIONAL]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.SALES_HUB_STARTER_ONBOARDING]: [{
        key: 'TALK_TO_SALES'
      }],
      [Products.CMS_HUB_STARTER]: [{
        key: 'BUY_TOUCHLESS'
      }],
      [Products.BRAND_DOMAIN]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.SERVICE_HUB_PROFESSIONAL_ONBOARDING]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.HUBSPOT_FOR_STARTUPS_SETUP]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.REPORTING_LIMIT_INCREASE]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }],
      [Products.TRANSCRIPTION_LIMIT_INCREASE]: [{
        key: 'BUY_TOUCHLESS'
      }, {
        key: 'TALK_TO_SALES'
      }]
    }
  }
};